var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{staticClass:"px-2",attrs:{"append-icon":"mdi-magnify","label":"Cautare...","single-line":"","hide-details":""},model:{value:(_vm.text),callback:function ($$v) {_vm.text=$$v},expression:"text"}})
}
var staticRenderFns = []

export { render, staticRenderFns }